import styled from '@emotion/styled';
import { memo } from 'react';
import { fill_vertical_all_center, } from '~/modules/AppLayout/FlexGridCss';
export const StockForum_Footer = memo(function StockForum_Footer() {
    return (<styleds.container>
      <span>
        版權所有© More Rich.摩爾證券投資顧問股份有限公司 All rights reserved. Moore Securities
        Investment Consulting Co., Ltd.
      </span>

      <span>
        本站資料僅供參考，本公司與推介分析之個別有價證券無不當之財務利益關係，過往之績效不代表未來獲利之保證，投資人應獨立判斷，審慎評估並自負投資風險。
      </span>
    </styleds.container>);
});
const styleds = {
    container: styled.div `
    ${fill_vertical_all_center};
    background-color: #f0f0f0;
    border-top: 1px solid #cccccc;
    color: #252525;
    font-size: 14px;
    & > * {
      padding: 4px;
    }
  `,
};
